export const canTransferJob = (request, currentInstaller) => {
  return (
    request.currentState === 'new' &&
    request.requestType === 'dealer' &&
    request.assignedTo === currentInstaller.installer_id
  );
};